// 使用对象字面量将检测类型放一起，循环遍历数组，查找到与type匹配的渲染类型（key），如果查找到，就返回对应渲染类型，没有找到就返回frame类型
const detectionTypes = {
    behavior: [
        'KITCHEN_STAFF_DETECT',
        'TRASH_DETECT',
        'FIRE_DETECTION_DETECT',
        'ABNORMAL_BEHAVIOR_DETECT',
        'TRAFFIC_RETROGRADE_DETECT',
        'TRAFFIC_VIOLATION_DETECT',
        'NONE_MOTOR_VEHICLE_PEDESTRIAN_DETECT',
        'TRAFFIC_CONGESTION_DETECT',
    ],
    crossBody: ['PEDESTRIAN_CROSS_LINE'],
    facePedestrian: ['FACE_PEDESTRIAN_ALERT'],
    face: ['FACE_ATTRIBUTE', 'FACE_ALERT'],
};
export function getRenderType(type) {
    for (const [renderType, types] of Object.entries(detectionTypes)) {
        if (types.includes(type)) {
            return renderType;
        }
    }
    return 'frame';
}
